import {Badge, IconButton, styled} from "@mui/material";

export const FilterIconButton = styled(IconButton)<{
    isActive?: boolean;
}>`
  background-color: ${({isActive}) => isActive ? 'rgba(177, 165, 165, 0.34)' : ''};
  &:hover {
      background-color: rgba(0, 0, 0, 0.04);
    }
  //border: ${({isActive}) => isActive ? '5px solid black' : ''};
  //box-shadow: ${({isActive}) => isActive ? '0px 0px 5px 0px rgba(177, 165, 165, 0.34)' : ''};
`;

export const CustomBadge = styled(Badge)<{ isFilter?: boolean }>`
  .MuiBadge-dot {
    background-color: ${({isFilter}) => (isFilter ? 'red' : '#F57B20')};
  }
`;
